import { useLayoutEffect, useRef } from "react";
import { createRoot } from "react-dom/client";
import cssText from "./XsmnV3Dark.shadow.css";
import useXsmnV3Light from "../XsmnV3Light/useXsmnV3Light";

const HOST_STYLE = {
  all: "initial",
  display: "block",
  width: "100%",
  maxWidth: "100%",
  margin: 0,
  padding: 0,
  border: 0,
  background: "transparent",
  boxSizing: "border-box",
  lineHeight: "normal",
  color: "#000",
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: "14px",
};

const SOUTH_HOME = [
  ["g8", "Giải tám", "9"],
  ["g7", "Giải bảy", "8"],
  ["g6", "Giải sáu", "7"],
  ["g5", "Giải năm", "6"],
  ["g4", "Giải tư", "5"],
  ["g3", "Giải ba", "4"],
  ["g2", "Giải nhì", "3"],
  ["g1", "Giải nhất", "2"],
  ["db", "Đặc biệt", "1"],
];

function regionCaption(name, draw) {
  return `Xổ số ${name} ${draw.weekdayLong} ${draw.dash}`;
}

function zipStations(stations, key) {
  const lists = stations.map((item) => item.prizes[key] || []);
  const max = Math.max(0, ...lists.map((list) => list.length));
  const out = [];
  for (let row = 0; row < max; row += 1) {
    lists.forEach((list) => {
      if (list[row] != null) out.push(list[row]);
    });
  }
  return out;
}

function NumberGrid({ values, prize, quantity }) {
  return (
    <div className="quantity-of-number" data-quantity={quantity}>
      {values.map((value, index) => (
        <span className="number" data-prize={prize} data-value={value} key={`${prize}-${index}`}>
          {value}
        </span>
      ))}
    </div>
  );
}

function ResultTable({ view }) {
  const caption = regionCaption(view.label, view.draw);
  if (view.pending || !view.stations.length) {
    return (
      <table className="table-fixed tbldata table-result-lottery">
        <caption>
          <h2>{caption}</h2>
        </caption>
        <tbody>
          <tr className="empty-row">
            <td>{view.pending ? "Đang tải kết quả..." : `Chưa có dữ liệu cho ngày ${view.draw.slash}.`}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  return (
    <table className="table-fixed tbldata table-result-lottery">
      <caption>
        <h2>{caption}</h2>
      </caption>
      <tbody>
        <tr>
          <td className="prize">Giải</td>
          <td className="results">
            <div className="quantity-of-number" data-quantity={view.stations.length}>
              {view.stations.map((item) => (
                <span className="wrap-text" key={item.key}>
                  {item.name}
                </span>
              ))}
            </div>
          </td>
        </tr>
        {SOUTH_HOME.map(([key, label, prize]) => {
          const values = zipStations(view.stations, key);
          return (
            <tr key={key}>
              <td className="prize">{label}</td>
              <td className="results">
                <NumberGrid values={values} prize={prize} quantity={view.stations.length} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

function XsmnV3Dark() {
  const view = useXsmnV3Light();
  return (
    <div className="xsmn-dark">
      <div className="block-results">
        <div className="block-result">
          <ResultTable view={view} />
        </div>
      </div>
    </div>
  );
}

function XsmnV3DarkHost() {
  const hostRef = useRef(null);
  const rootRef = useRef(null);

  useLayoutEffect(() => {
    const host = hostRef.current;
    if (!host) return undefined;
    const shadow = host.shadowRoot ?? host.attachShadow({ mode: "open" });
    let style = shadow.querySelector("style[data-xsmn-v3-dark]");
    if (!style) {
      style = document.createElement("style");
      style.setAttribute("data-xsmn-v3-dark", "");
      shadow.appendChild(style);
    }
    style.textContent = cssText;
    let mount = shadow.querySelector("[data-xsmn-dark-mount]");
    if (!mount) {
      mount = document.createElement("div");
      mount.setAttribute("data-xsmn-dark-mount", "");
      shadow.appendChild(mount);
    }
    if (!rootRef.current) rootRef.current = createRoot(mount);
    rootRef.current.render(<XsmnV3Dark />);
    return () => {
      rootRef.current?.unmount();
      rootRef.current = null;
    };
  }, [cssText]);

  return <div ref={hostRef} className="xsmn-dark-host" style={HOST_STYLE} />;
}

export default XsmnV3DarkHost;
